"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpanderSize = exports.ExpanderLayout = exports.ExpanderChevronPosition = void 0;
let ExpanderLayout = exports.ExpanderLayout = /*#__PURE__*/function (ExpanderLayout) {
  ExpanderLayout["Default"] = "default";
  ExpanderLayout["Card"] = "card";
  return ExpanderLayout;
}({});
let ExpanderChevronPosition = exports.ExpanderChevronPosition = /*#__PURE__*/function (ExpanderChevronPosition) {
  ExpanderChevronPosition["Leading"] = "leading";
  ExpanderChevronPosition["Trailing"] = "trailing";
  return ExpanderChevronPosition;
}({});
let ExpanderSize = exports.ExpanderSize = /*#__PURE__*/function (ExpanderSize) {
  ExpanderSize["Default"] = "default";
  ExpanderSize["Small"] = "small";
  return ExpanderSize;
}({});